import { render } from "./Tiles.vue?vue&type=template&id=fff3082a&scoped=true"
import script from "./Tiles.vue?vue&type=script&lang=js"
export * from "./Tiles.vue?vue&type=script&lang=js"

import "./Tiles.vue?vue&type=style&index=0&id=fff3082a&scoped=true&lang=css"
import "./Tiles.vue?vue&type=style&index=1&id=fff3082a&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff3082a"]])

export default __exports__